/**
 * Sprint 23.7 — `<RailSection>`: a thin grouping wrapper that gives each rail
 * cluster (Surfaces, Utility) its consistent top spacing. No visual chrome of
 * its own — just rhythm between groups of `<RailItem>`s.
 */

import { type CSSProperties, type ReactNode } from "react";

export interface RailSectionProps {
  children: ReactNode;
  /** Vertical gap above this section (px). Defaults to 12. */
  spacingTop?: number;
}

export function RailSection({ children, spacingTop = 12 }: RailSectionProps) {
  const style: CSSProperties = {
    paddingTop: spacingTop,
    display: "flex",
    flexDirection: "column",
    gap: 1,
  };
  return <div style={style}>{children}</div>;
}
